import { render } from "./IconShoppingCartCheckout.vue?vue&type=template&id=70e79685"
import script from "./IconShoppingCartCheckout.vue?vue&type=script&lang=js"
export * from "./IconShoppingCartCheckout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__